import { Avatar, Box, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import AppButton from '../../../../components/ui/AppButton';

const LineUserCard = ({ src, name, onClick }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <ListItem alignItems="center" sx={{ paddingLeft: '0' }}>
        <ListItemAvatar>
          <Avatar src={src} />
        </ListItemAvatar>
        <ListItemText primary={name} primaryTypographyProps={{ sx: { fontSize: '1.25rem' } }} />
      </ListItem>
      <AppButton
        variant="text"
        onClick={onClick}
        sx={{
          fontSize: '1.25rem',
          width: '120px',
          height: '45px',
          color: 'white',
          backgroundColor: '#dc2626',
          textTransform: 'capitalize',

          '&:hover': {
            color: 'white',
            backgroundColor: '#dc2626',
            opacity: '0.85',
          },
        }}
      >
        ส่ง
      </AppButton>
    </Box>
  );
};

export default LineUserCard;
